import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  constructor(private translate: TranslateService) {}

  splitWeekDay(day: number) {
    let week = Math.floor((day - 1) / 7) + 1;
    if (day == 0) {
      week = 1;
    }

    day = day - (week - 1) * 7;

    return [week, day];
  }

  convertDayToDisplay(day: number) {
    const [week, remainderDay] = this.splitWeekDay(day);
    return (
      this.translate.instant('WEEK') +
      ' ' +
      week +
      ', ' +
      this.translate.instant('DAY').toLowerCase() +
      ' ' +
      remainderDay
    );
  }
}
